import React from "react";
import stylesLess from "./index.module.less";

const CodeDiv = ({ index, value, isFocus }) => {
  const len = value ? value.length : 0;
  const txt = value ? value[index] || "" : "";

  const isCurFocus = isFocus && len === index;
  const classList = ["iCode"];
  isCurFocus && classList.push("focus");

  return (
    <div className={classList.join(" ")}>
      {txt ? txt : <>{isCurFocus && <i></i>}</>}
    </div>
  );
};

export default React.forwardRef(function Passcode(props, ref) {
  const { errMsg, value, onInput, onFocus, onBlur, ...rest } = props;

  const [state_isFocus, setState_isFocus] = React.useState(false);

  const handleInput = (e) => {
    const val = e.target.value;
    if (/^[0-9]{0,6}$/.test(val)) onInput && onInput(val);
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData || {}).getData("text") || "";
    const digits = pasted.replace(/\D/g, "").slice(0, 6);
    if (digits) onInput && onInput(digits);
  };
  const handleInputFocus = (e) => {
    // console.log("handleInputFocus", state);
    setState_isFocus(true);
    onFocus && onFocus(e);
  };
  const handleInputBlur = (e) => {
    console.log("handleInputBlur", e);
    setState_isFocus(false);
    onBlur && onBlur(e);
  };

  const classList = [stylesLess.main];
  errMsg && classList.push("err");

  return (
    <div className={`${classList.join(" ")}`}>
      <div className={"iCodeCon"}>
        <div>
          <CodeDiv index={0} value={value} isFocus={state_isFocus} />
          <CodeDiv index={1} value={value} isFocus={state_isFocus} />
          <CodeDiv index={2} value={value} isFocus={state_isFocus} />
          <CodeDiv index={3} value={value} isFocus={state_isFocus} />
          <CodeDiv index={4} value={value} isFocus={state_isFocus} />
          <CodeDiv index={5} value={value} isFocus={state_isFocus} />
        </div>
        <input
          ref={ref}
          value={value}
          autoComplete="new-password"
          maxLength="6"
          type="tel"
          inputMode="numeric"
          onInput={handleInput}
          onPaste={handlePaste}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          {...rest}
        />
      </div>
      {errMsg && <div className={"iErrMsg"}>{errMsg}</div>}
    </div>
  );
});
